// Global constants

export const APP_NAME = '联脉';
export const APP_VERSION = '1.0.0';

export const NAV_LINKS = [
  { label: '工作流', href: '#workflow' },
  { label: '应用场景', href: '#scenarios' },
  { label: '价格', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
  { label: '开始使用', href: '/research', highlight: true },
];

export const SCENARIO_OPTIONS = [
  { value: 'foreign_trade', label: '外贸' },
  { value: 'marketing', label: '投放' },
  { value: 'recruitment', label: '招聘' },
  { value: 'other', label: '其他' },
];

export const MARKET_OPTIONS = [
  { value: 'north_america', label: '北美' },
  { value: 'europe', label: '欧洲' },
  { value: 'southeast_asia', label: '东南亚' },
  { value: 'china', label: '中国大陆' },
  { value: 'other', label: '其他' },
];

export const VOLUME_OPTIONS = [
  { value: '1-50', label: '1-50 人/月' },
  { value: '51-200', label: '51-200 人/月' },
  { value: '201-500', label: '201-500 人/月' },
  { value: '500+', label: '500+ 人/月' },
];

export const FOOTER_SECTIONS = [
  {
    title: '合规与资源',
    links: [
      { label: '隐私政策', href: '#' },
      { label: '用户协议', href: '#' },
      { label: '信息安全白皮书', href: '#' },
    ],
  },
  {
    title: '联系我们',
    links: [
      { label: 'contact@reachflow.ai', href: 'mailto:contact@reachflow.ai' },
      { label: '400-XXX-XXXX', href: 'tel:400-XXX-XXXX' },
    ],
  },
];

export const COMPANY_INFO = {
  name: '联脉科技',
  description: '用 AI 精准识别企业关键联系人，补全多通道触达方式，并验证可达性。',
  email: 'contact@reachflow.ai',
  phone: '400-XXX-XXXX',
  icp: '京ICP备XXXXXXXX号',
  copyright: '联脉科技',
};
